import $ from 'jquery';
import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/datepicker';

const $datepicker = $('.datepicker');

$(function () {
    $.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
    $.datepicker._updateDatepicker = function (inst) {
        $.datepicker._updateDatepicker_original(inst);
        let afterShow = this._get(inst, 'afterShow');
        if (afterShow) afterShow.apply(inst.input ? inst.input[0] : null);
    };

    $datepicker.datepicker({
        firstDay: 1,
        dateFormat: 'dd.mm.yy',
        dayNames: ['Nedeľa', 'Pondelok', 'Utorok', 'Streda', 'Štvrtok', 'Piatok', 'Sobota'],
        dayNamesMin: ['Ne', 'Po', 'Ut', 'St', 'Št', 'Pi', 'So'],
        monthNames: ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December'],
        prevText: '◄',
        nextText: '►',
        showOtherMonths: true,
        selectOtherMonths: true,
        showAnim: 'fadeIn',
        afterShow: function () {
            const $prev = $('.ui-datepicker-prev');
            const $next = $('.ui-datepicker-next');

            if ($prev.prop('title') !== '') {
                $prev.prop('title', '');
            }
            if ($next.prop('title') !== '') {
                $next.prop('title', '');
            }
        },
    });
});
